import React, { useEffect, useState, useRef } from "react";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { alpha, makeStyles } from "@material-ui/core/styles";

import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/core/Menu";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import firebaseApp from "../firebaseApp";

import Popper from "@material-ui/core/Popper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import classNames from "classnames";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import useCurrentUser from "./useCurrentUser";
import logoSvg from "../images/logo.svg";
import SignInScreen from "./SigninScreen";

const useStyles = makeStyles((theme) => ({
  title: {
    paddingRight: theme.spacing(5),
    overflow: "visible",
  },
  logo: {
    maxHeight: 35,
    marginRight: theme.spacing(1),
  },
  link: {
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    textDecoration: "none",
    color: "white",
  },
  popper: {
    zIndex: theme.zIndex.drawer + 2,
  },
  popperLogin: {
    marginRight: 0,
    [theme.breakpoints.down("sm")]: {
      marginRight: 70,
    },
  },
  paper: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    minWidth: 100,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
  navButton: {
    marginLeft: 8,
    fontSize: "1rem",
  },
  moreButton: {
    color: "white",
  },
  right: {
    display: "flex",
  },
  avatar: {
    marginLeft: theme.spacing(2),
    cursor: "pointer",
  },
  children: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function NavbarContent({ children }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElLogin, setAnchorElLogin] = useState(null);
  let handleClose = () => {
    setAnchorEl(null);
  };
  const [open, setOpen] = useState(false);

  const anchorRef = useRef(null);

  const handleClick = (event) => {
    setAnchorElLogin(anchorRef.current);
    setOpen(true);
    handleClose();
  };

  const id = open ? "simple-popper" : undefined;

  const handleCloseLogin = () => {
    console.log("handle close");
    setOpen(false);
  };

  const [currentUser] = useCurrentUser();

  const auth = getAuth(firebaseApp);

  return (
    <>
      <Link to="/" className={classes.link}>
        <img alt="loomhack logo" className={classes.logo} src={logoSvg} />
        <Typography
          className={classes.title}
          variant="h5"
          color="inherit"
          noWrap
        >
          LoomHack
        </Typography>
      </Link>
      <div className={classes.children}>{children}</div>

      <Hidden smDown implementation="css">
        <div className={classes.right}>
          {!currentUser && (
            <Button
              className={classes.navButton}
              color="secondary"
              ref={anchorRef}
              onClick={handleClick}
            >
              Log In
            </Button>
          )}
          {currentUser && (
            <Avatar
              className={classes.avatar}
              src={currentUser.photoURL}
              ref={anchorRef}
              onClick={handleClick}
            />
          )}
        </div>
      </Hidden>
      <Hidden mdUp>
        <IconButton
          className={classes.moreButton}
          aria-label="More"
          aria-haspopup="true"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {currentUser ? (
            <MenuItem>
              <ListItemIcon>
                <Avatar src={currentUser.photoURL} ref={anchorRef} />
              </ListItemIcon>
              <Typography variant="inherit">
                {currentUser.displayName}
              </Typography>
            </MenuItem>
          ) : (
            <MenuItem ref={anchorRef} onClick={handleClick}>
              Log In
            </MenuItem>
          )}
          {currentUser && (
            <MenuItem onClick={() => auth.signOut()}>Logout</MenuItem>
          )}
        </Menu>
      </Hidden>
      <ClickAwayListener
        mouseEvent="onMouseDown"
        touchEvent="onTouchStart"
        onClickAway={handleCloseLogin}
      >
        <Popper
          id={id}
          open={open}
          anchorEl={anchorElLogin}
          className={classNames(
            classes.popper,
            !currentUser && classes.popperLogin
          )}
        >
          <Paper className={classes.paper}>
            <SignInScreen
              showLogout
              handleClose={handleCloseLogin}
              currentUser={currentUser}
            />
          </Paper>
        </Popper>
      </ClickAwayListener>
    </>
  );
}
